// VisaReports.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, ArrowRight, Construction, Search, Filter, Printer } from 'lucide-react';

const VisaReports = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-3">
              <BarChart3 className="h-8 w-8 text-indigo-600" />
              <h1 className="text-2xl font-bold text-gray-900">تقارير التأشيرات</h1>
            </div>
            <button 
              onClick={goBack}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors duration-200"
            >
              <ArrowRight size={16} />
              العودة للرئيسية
            </button>
          </div>

          {/* Description */}
          <div className="bg-blue-50 border-r-4 border-blue-400 p-6 rounded-lg mb-6">
            <div className="flex items-center">
              <Search className="h-6 w-6 text-blue-600 ml-3" />
              <div>
                <h2 className="text-lg font-semibold text-blue-800 mb-2">
                  صفحة البحث والتقارير المتقدمة
                </h2>
                <p className="text-blue-700 leading-relaxed">
                  هذه الصفحة مخصصة لجلب أي معلومة عن أي شخص عن طريق البحث والفلترة المتقدمة والطباعة.
                  يمكنك من خلالها الوصول إلى جميع بيانات التأشيرات والجوازات بطريقة سهلة ومرنة.
                </p>
              </div>
            </div>
          </div>

          {/* Under Development Message */}
          <div className="bg-amber-50 border-r-4 border-amber-400 p-6 rounded-lg">
            <div className="flex items-center">
              <Construction className="h-8 w-8 text-amber-600 ml-3" />
              <div>
                <h2 className="text-lg font-semibold text-amber-800 mb-2">
                  صفحة تحت التطوير
                </h2>
                <p className="text-amber-700 leading-relaxed">
                  سيتم إضافة الميزات التالية قريباً:
                </p>
                <ul className="list-disc list-inside mt-3 text-amber-700 space-y-1">
                  <li>البحث المتقدم في جميع قواعد البيانات</li>
                  <li>فلترة البيانات حسب معايير متعددة</li>
                  <li>تقارير مخصصة وقابلة للتصدير</li>
                  <li>طباعة التقارير بتنسيقات مختلفة</li>
                  <li>حفظ عمليات البحث المتكررة</li>
                  <li>إحصائيات تفصيلية ورسوم بيانية</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Placeholder Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <div className="flex items-center gap-2 mb-2">
                <Search className="h-5 w-5 text-green-600" />
                <h3 className="font-semibold text-green-800">البحث المتقدم</h3>
              </div>
              <p className="text-green-600 text-sm">البحث في جميع قواعد البيانات بمعايير متعددة</p>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <div className="flex items-center gap-2 mb-2">
                <Filter className="h-5 w-5 text-blue-600" />
                <h3 className="font-semibold text-blue-800">الفلترة الذكية</h3>
              </div>
              <p className="text-blue-600 text-sm">فلترة البيانات حسب التاريخ والحالة والنوع</p>
            </div>
            
            <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
              <div className="flex items-center gap-2 mb-2">
                <Printer className="h-5 w-5 text-purple-600" />
                <h3 className="font-semibold text-purple-800">الطباعة المتقدمة</h3>
              </div>
              <p className="text-purple-600 text-sm">طباعة التقارير بتنسيقات متعددة</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaReports;